const TagsDetailsViewStyles = {
  pageHeader: {
    paddingTop: "10px",
    paddingBottom: "10px"
  }
};

export default TagsDetailsViewStyles;